import classnames from 'classnames';
import { isArray } from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import useCotizacion from 'src/hooks/useCotizacion';
import { roundTo } from 'src/utils/functiones';
import { ImpuestoLabel, ImpuestoValue, StyledButtonVerMas } from '../styleds';

const Impuestos = ({ impuestos = [], moneda = { signo: "", sigla: '' } }) => {

  const [show, setShow] = useState(false);
  const { cotizacion } = useCotizacion()
  const { valoresPagar, producto } = cotizacion;
  let { impuestosVisibles = [] } = producto

  const [impuestosComp, setimpuestosComp] = useState(null)



  useEffect(useCallback(() => {
    console.log('useefeectImpuestos')
    if (impuestos.length === 0 && impuestosVisibles.length === 0 || (impuestos.length > 0 && !impuestos[0])) {
      setimpuestosComp(null);
      return
    }
    let imp = [...impuestos];
    if (imp.length === 0) {
      imp.push(['Subtotal:', roundTo(valoresPagar?.subtotal)]);
      if (isArray(impuestosVisibles)) {
        impuestosVisibles.forEach(element => {
          imp.push([`${element}:`, roundTo(valoresPagar?.calculos?.[element])]);
        });
      }
    }
    const res = imp
      .filter((item) => item[1])
      .map(([label, value], index) => (
        <div className="d-flex justify-content-between" style={{ margin: 0 }} key={index}>
          {/* <div className="col-12 justify-content-between"> */}
          <ImpuestoLabel className=" d-flex  ">{label}</ImpuestoLabel>
          <ImpuestoValue className=" d-flex">
            {moneda?.signo}
            {value} {moneda?.sigla}
          </ImpuestoValue>
        </div>
      ));
    setimpuestosComp(res);
  }, []), [moneda, impuestos, impuestosVisibles, valoresPagar])

  // const impuestosComponent = useMemo(() => {

  // }, [moneda, impuestos]);

  // </div>
  const onClick = () => setShow(!show);

  if (!impuestosComp) return null

  return (
    <React.Fragment>
      <div className="d-flex flex-row justify-content-center mb-2">
        <h4 className="label__impuestos">Incluidos impuestos</h4>
        <StyledButtonVerMas onClick={onClick}>
          Ver más{' '}
          <i
            className={classnames({
              pi: true,
              'pi-chevron-up': show,
              'pi-chevron-down': !show,
            })}
          />
        </StyledButtonVerMas>
      </div>
      {show && <div className="animate__animated animate__fadeIn row justify-content-center">
        <div className="col-11 col-md-7">
          {impuestosComp}
        </div>
      </div>}
    </React.Fragment>
  );
};


export default Impuestos;
